import numeral from "numeral";
import { useEffect, useMemo, useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useDebtStore } from "../../../_store/debtplanStore";
import { useEducationStore } from "../../../_store/educationStore";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { useRetireStore } from "../../../_store/retireStore";
import { useUserStore } from "../../../_store/userStore";
import {
  DonutChartEmpty,
  DonutChartProperty,
} from "../../../components/chart/DonutChartMain";
import {
  sumCapitalInvest,
  sumDebtInvest,
  sumPersonalAsset,
} from "../../../functions/Balance/sumProperty";
import {
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "../../../functions/Balance/sumValueBalance";
import { cn } from "../../../utils/useFunctions";
import {
  ICON_BUILDING,
  ICON_CONTRACT,
  ICON_HOUSE,
} from "../../../utils/useIcons";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_13,
  STYLE_PDF_TEXT_MEDIUM_BLUE_13,
} from "../styles/pdf.style";

function PdfPageOVPropertyOne({ page }) {
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const educationData = useEducationStore((state) => state.educationData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const debtData = useDebtStore((state) => state.debtData);
  const userData = useUserStore((state) => state.userData);
  const retireData = useRetireStore((state) => state.retireData);

  const [tempBalance, setTempBalance] = useState(balanceData);
  const [ReturnInsurance, setReturnInsurance] = useState([]);
  const [addInvest, setAddInvest] = useState(
    balanceData?.property_invest_list ? balanceData?.property_invest_list : []
  );

  useEffect(() => {
    if (tempBalance) {
      let tempInsuranceReturn = tempBalance?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        tempBalance?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = tempBalance?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = tempBalance?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
    //==============================================//
  }, [balanceData]);

  const sumAllProportion = useMemo(() => {
    return (
      Number(balanceData?.sum_property_asset || 0) +
      SumDebtPersonalValue(balanceData) +
      sumCapitalInvest(addInvest, ReturnInsurance) +
      sumDebtInvest(balanceData) +
      sumPersonalAsset(balanceData?.property_private_list) +
      SumOtherDebtAmount(balanceData) +
      Number(balanceData?.sum_property_intangible || 0)
    );
  }, [balanceData]);

  const createSumObject = (sum_per_month, sum_per_year, sum_percent) => ({
    sum_per_month: sum_per_month || 0,
    sum_per_year: sum_per_year || 0,
    sum_percent: sum_percent || 0,
  });

  const sumAsset = useMemo(() => {
    return createSumObject(
      0,
      balanceData?.sum_property_asset,
      (balanceData?.sum_property_asset / sumAllProportion) * 100
    );
  }, [balanceData]);

  const sumPropertyInvest = useMemo(() => {
    let sumValue =
      SumDebtPersonalValue(balanceData) +
      sumCapitalInvest(addInvest, ReturnInsurance) +
      sumDebtInvest(balanceData);

    return createSumObject(0, sumValue, (sumValue / sumAllProportion) * 100);
  }, [balanceData]);

  const sumPropertyPrivate = useMemo(() => {
    let sumValue =
      sumPersonalAsset(balanceData?.property_private_list) +
      SumOtherDebtAmount(balanceData);

    return createSumObject(0, sumValue, (sumValue / sumAllProportion) * 100);
  }, [balanceData]);

  const sumPropertyIntangible = useMemo(() => {
    return createSumObject(
      0,
      balanceData?.sum_property_intangible,
      (balanceData?.sum_property_intangible / sumAllProportion) * 100
    );
  }, [balanceData]);

  const items = useMemo(() => {
    return [
      {
        title: "สินทรัพย์สภาพคล่อง",
        icon: "proporty_asset2.png",
        classNameIcon: "w-[20px]",
        ...sumAsset,
      },
      {
        title: "สินทรัพย์เพื่อการลงทุน",
        iconFull: (
          <ICON_BUILDING classNames=" w-5 h-5 fill-[#7f1eff] stroke-[#7f1eff] " />
        ),
        classNameIcon: "w-[20px]",
        ...sumPropertyInvest,
      },
      {
        title: "สินทรัพย์ใช้ส่วนตัว",
        iconFull: (
          <ICON_HOUSE classNames=" w-5 h-5 stroke-[#8c37fc] fill-none " />
        ),
        classNameIcon: "w-[20px]",
        ...sumPropertyPrivate,
      },
      {
        title: "สินทรัพย์ไม่มีตัวตน",
        iconFull: (
          <ICON_CONTRACT classNames=" w-5 h-5 fill-[#8D32E8] stroke-[#8D32E8] " />
        ),
        classNameIcon: "w-[20px]",
        ...sumPropertyIntangible,
      },
    ];
  }, [sumAllProportion]);


  return (
    <div
      style={{
        backgroundImage: `url(/images/bg_pdf.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
      }}
      className={cn(STYLE_PAGE)}
    >
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="สัดส่วนสินทรัพย์ของคุณ"
        icon="/images/payment_(1).svg"
      />
      <PdfCard>
        <PdfCardWhite>
          {/* <div className={cn("text-center", STYLE_PDF_TEXT_MEDIUM_12)}>
            สัดส่วนสินทรัพย์ของคุณ
          </div> */}

          <div className="">
            {sumAllProportion <= 0 || sumAllProportion === undefined ? (
              <DonutChartEmpty
                text={`สินทรัพย์`}
                labelLists={[
                  {
                    name: "สินทรัพย์สภาพคล่อง",
                    value: balanceData?.sum_property_asset,
                    color: "#550793",
                  },
                  {
                    name: "สินทรัพย์เพื่อการลงทุน",
                    value:
                      SumDebtPersonalValue(balanceData) +
                      sumCapitalInvest(addInvest, ReturnInsurance) +
                      sumDebtInvest(balanceData),
                    color: "#CBA4FF",
                  },
                  {
                    name: "สินทรัพย์ใช้ส่วนตัว",
                    value:
                      // Number(balanceData?.sum_property_private || 0) +
                      sumPersonalAsset(balanceData?.property_private_list) +
                      SumOtherDebtAmount(balanceData),
                    color: "#B780FF",
                  },
                  {
                    name: "สินทรัพย์ไม่มีตัวตน",
                    value: balanceData?.sum_property_intangible,
                    color: "#8D32E8",
                  },
                ]}
              />
            ) : (
              <DonutChartProperty
                text={`สินทรัพย์`}
                value={numeral(sumAllProportion).format("0,0")}
                data1={balanceData?.sum_property_asset}
                data2={
                  SumDebtPersonalValue(balanceData) +
                  sumCapitalInvest(addInvest, ReturnInsurance) +
                  sumDebtInvest(balanceData)
                }
                data3={
                  sumPersonalAsset(balanceData?.property_private_list) +
                  SumOtherDebtAmount(balanceData)
                }
                data4={balanceData?.sum_property_intangible}
                labelLists={[
                  {
                    name: "สินทรัพย์สภาพคล่อง",
                    value: balanceData?.sum_property_asset,
                    color: "#550793",
                  },
                  {
                    name: "สินทรัพย์เพื่อการลงทุน",
                    value:
                      SumDebtPersonalValue(balanceData) +
                      sumCapitalInvest(addInvest, ReturnInsurance) +
                      sumDebtInvest(balanceData),
                    color: "#CBA4FF",
                  },
                  {
                    name: "สินทรัพย์ใช้ส่วนตัว",
                    value:
                      sumPersonalAsset(balanceData?.property_private_list) +
                      SumOtherDebtAmount(balanceData),
                    color: "#B780FF",
                  },
                  {
                    name: "สินทรัพย์ไม่มีตัวตน",
                    value: balanceData?.sum_property_intangible,
                    color: "#8D32E8",
                  },
                ]}
                classNameGray={"bg-white"}
                isRemoveGray
                isRemoveLegend
                classNameDonut={"w-[200px] top-4 mb-2"}
                classNameText={cn("text-lg top-[55%]")}
                classNameValue={cn("text-lg")}
              />
            )}
          </div>

          <div
            className={cn(
              "grid grid-cols-4 px-3 items-center",
              STYLE_PDF_TEXT_MEDIUM_12
            )}
          >
            <div className="col-span-2">สินทรัพย์</div>
            {/* <div className={cn("text-right")}>ต่อเดือน (บาท)</div> */}
            <div className={cn("text-right")}>จำนวน (บาท)</div>
            <div className={cn("text-right")}>%</div>
          </div>
          <PdfLine className={"mb-1 mt-1"} />

          <div className="flex flex-col space-y-2">
            {items?.map((item, index) => {
              return (
                <div
                  key={index}
                  className={cn(
                    "grid grid-cols-4 px-3 items-center",
                    STYLE_PDF_TEXT_MEDIUM_12
                  )}
                >
                  <div className="flex col-span-2 space-x-2">
                    <div>
                      {item?.icon && (
                        <img
                          className={cn(item?.classNameIcon)}
                          src={`/images/${item.icon}`}
                        />
                      )}
                      {item?.iconFull && item?.iconFull}
                    </div>
                    <div>{item.title}</div>
                  </div>
                  <div className="text-right">
                    {numeral(item.sum_per_year).format("0,0")}
                  </div>
                  <div className="text-right">
                    {numeral(item.sum_percent).format("0.00")}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex justify-center items-center space-x-1 mt-2">
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_13)}>
              รวมสินทรัพย์ทั้งหมด
            </div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_13)}>
              {numeral(sumAllProportion).format("0,0")}
            </div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_13)}>บาท</div>
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageOVPropertyOne;
